export default "__VITE_ASSET__zfv5HtvW__"